import { Component } from '@angular/core';
import { MenuLanguageService } from './services/menu-language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ClientApp';

  constructor(private readonly menuLanguageService: MenuLanguageService) {
    this.menuLanguageService.initialize(this.readProfileLanguage());
  }

  private readProfileLanguage(): number | string | null {
    if (typeof localStorage === 'undefined') return null;
    for (const key of ['userInformation', 'invitatedUserInformation']) {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) continue;
        const profile = JSON.parse(raw);
        const language = profile?.lenguajeType ?? profile?.LenguajeType;
        if (language !== undefined && language !== null) return language;
      } catch {
        // A malformed stale profile must not prevent application startup.
      }
    }
    return null;
  }

}
